
export const REG_IS_GET_CODE = "reg_is_get_code";
export const LOGIN_DATA = "login_data";